/**
 * Reset security flow type enum.
 */
export enum RESET_SECURITY_FLOW_TYPE {
  PASSWORD = 'password',
  TOTP = 'totp', // See CONTACT_MFA_TYPE.TOTP
}
